import { NgIf } from '@angular/common';
import { ChangeDetectorRef, Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { SagepayCloudPaymentService } from './sagepay-cloud-payment.service';

@Directive()
export abstract class IfSagepayCloudPaymentActiveDirectiveDef extends NgIf implements OnInit, OnDestroy {
    protected subscriptions = new Subscription();

    private value = false;
    
    sagepayCloudPayment= inject(SagepayCloudPaymentService);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        this.subscriptions.add(this.sagepayCloudPayment.storeIdSubject.subscribe(() => this.update()));
        this.update();
    }

    ngOnDestroy() {
        this.subscriptions?.unsubscribe();
    }

    protected getValue() {
        return this.sagepayCloudPayment.isSpcp();
    }

    protected update() {
        const value = this.getValue();
        
        if (this.value !== value) {
            this.value = value;
            this.ngIf = value;
            this.changeDetectorRef.detectChanges();
        }
    }
}